import { i18n } from '../i18n';
import { resolveLanguage } from '../languageRegistry';
/** Compatibility for the old Seed card; all strings now live in the catalogs. */
export const resolveLanguageData = (language: string): any =>
  i18n.getResourceBundle(resolveLanguage(language), 'legacy') ||
  i18n.getResourceBundle('en', 'legacy');
